const FA_DATETIME = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
  year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit',
});

export const formatTaskDate = (iso) => (iso ? FA_DATETIME.format(new Date(iso)) : '—');

export const TASK_STATUS = {
  draft: { label: 'پیش‌نویس', variant: 'gray' },
  open: { label: 'در انتظار انجام', variant: 'amber' },
  responded: { label: 'در انتظار تایید مدیر', variant: 'blue' },
  approved: { label: 'تایید شده', variant: 'green' },
};

/** Badge for a task, accounting for the employee's answer and lateness. */
export function taskStatusInfo(task) {
  if (task.status === 'responded' && task.response_result === 'not_done') {
    return { label: 'انجام نشده (در انتظار بررسی مدیر)', variant: 'red' };
  }
  if (task.status === 'open' && task.reject_count > 0) {
    return { label: 'بازگردانده شد', variant: 'orange' };
  }
  return TASK_STATUS[task.status] || TASK_STATUS.draft;
}

/** "۲ روز و ۳ ساعت مانده" / "۵ ساعت گذشته" */
export function deadlineCountdown(iso, now = Date.now()) {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - now;
  const abs = Math.abs(diff);
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const minutes = Math.floor((abs % 3600000) / 60000);
  let text;
  if (days > 0) text = `${days} روز${hours ? ` و ${hours} ساعت` : ''}`;
  else if (hours > 0) text = `${hours} ساعت${minutes ? ` و ${minutes} دقیقه` : ''}`;
  else text = `${minutes} دقیقه`;
  return diff >= 0 ? `${text} مانده` : `${text} گذشته`;
}

export const TASK_FILTERS = [
  { id: '', label: 'همه' },
  { id: 'pending', label: 'در انتظار انجام' },
  { id: 'responded', label: 'در انتظار تایید' },
  { id: 'approved', label: 'انجام شده' },
  { id: 'overdue', label: 'گذشته از ددلاین' },
];
